var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingscopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10.7338V9.26718C1.6665 8.40052 2.37484 7.68385 3.24984 7.68385C4.75817 7.68385 5.37484 6.61718 4.6165 5.30885C4.18317 4.55885 4.4415 3.58385 5.19984 3.15052L6.6415 2.32552C7.29984 1.93385 8.14984 2.16718 8.5415 2.82552L8.63317 2.98385C9.38317 4.29218 10.6165 4.29218 11.3748 2.98385L11.4665 2.82552C11.8582 2.16718 12.7082 1.93385 13.3665 2.32552L14.8082 3.15052C15.5665 3.58385 15.8248 4.55885 15.3915 5.30885C14.6332 6.61718 15.2498 7.68385 16.7582 7.68385C17.6248 7.68385 18.3415 8.39218 18.3415 9.26718V10.7338C18.3415 11.6005 17.6332 12.3172 16.7582 12.3172C15.2498 12.3172 14.6332 13.3838 15.3915 14.6922C15.8248 15.4505 15.5665 16.4172 14.8082 16.8505L13.3665 17.6755C12.7082 18.0672 11.8582 17.8339 11.4665 17.1755L11.3748 17.0172C10.6248 15.7089 9.3915 15.7089 8.63317 17.0172L8.5415 17.1755C8.14984 17.8339 7.29984 18.0672 6.6415 17.6755L5.19984 16.8505C4.4415 16.4172 4.18317 15.4422 4.6165 14.6922C5.37484 13.3838 4.75817 12.3172 3.24984 12.3172C2.37484 12.3172 1.6665 11.6005 1.6665 10.7338Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingscopy);
export default __webpack_public_path__ + "static/media/Settings copy.7553039cac86801a6c32b2430fb6c5fd.svg";
export { ForwardRef as ReactComponent };